module.exports = __webpack_public_path__ + "Flama-Black.woff?88c7079b8b962c059366e644c4a61e6b";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Flama-Black.woff
// module id = 924
// module chunks = 0